export default __webpack_public_path__ + "static/media/Flensted-memorabilia-mobile-2.6508b3ea.jpg";